const metaFields = `
    title,
    slug,   
    meta {
        openGraphImage,
        seoTitle,
        seoDescription,
        seoTwitterCardStyle,
    },
`;

export default metaFields;
